import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';
import CortexIndex from './pages/CortexIndex.vue';

const meta = {
  permissions: ['administrator', 'can_manage_cortex', 'can_view_cortex_audit'],
  featureFlag: FEATURE_FLAGS.CORTEX,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/cortex'),
    redirect: to => ({
      name: 'cortex_index',
      params: {
        ...to.params,
        navigationPath: 'overview',
      },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/cortex/:navigationPath'),
    component: CortexIndex,
    name: 'cortex_index',
    meta,
  },
];
